var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Linkedin = function Linkedin(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm6 2a1 1 0 0 0-2 0v.01a1 1 0 0 0 2 0V8Zm0 3a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Zm3-1c.276 0 .526.112.707.293A3 3 0 0 1 17 13v3a1 1 0 1 1-2 0v-3a1 1 0 0 0-2 0v3a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Linkedin;